import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

function Dashboard({ onNewProject, onLoadProject }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: '', projectNumber: '', client: '', preparedBy: '', checkedBy: ''
  });

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => setUser(user));
    fetchProjects();
  }, []);

  async function fetchProjects() {
    setLoading(true);
    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .order('created_at', { ascending: false });
    if (!error) setProjects(data || []);
    setLoading(false);
  }

  async function deleteProject(id) {
    if (!window.confirm('Delete this project?')) return;
    const { error } = await supabase.from('projects').delete().eq('id', id);
    if (!error) fetchProjects();
  }

  function handleCreate() {
    if (!form.name.trim()) return;
    onNewProject({
      name: form.name.trim(),
      projectNumber: form.projectNumber.trim(),
      client: form.client.trim(),
      preparedBy: form.preparedBy.trim(),
      checkedBy: form.checkedBy.trim(),
    });
  }

  function field(label, key, placeholder, required = false) {
    return (
      <div style={{ marginBottom: 10 }}>
        <label style={{ display: 'block', fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6B6880', marginBottom: 4 }}>
          {label}{required && <span style={{ color: '#E8001C' }}> *</span>}
        </label>
        <input
          type="text"
          value={form[key]}
          onChange={e => setForm(prev => ({ ...prev, [key]: e.target.value }))}
          onKeyDown={e => e.key === 'Enter' && key === 'checkedBy' && handleCreate()}
          placeholder={placeholder}
          autoFocus={key === 'name'}
          style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1.5px solid #EDE5F8', fontSize: 13, fontFamily: 'inherit', color: '#1C1C2E', outline: 'none', boxSizing: 'border-box', background: '#FAFAFA' }}
        />
      </div>
    );
  }

  async function handleLogout() {
    await supabase.auth.signOut();
  }

  return (
    <div style={{ minHeight: '100vh', background: '#F6F1E9', fontFamily: 'Nunito Sans, Avenir, sans-serif' }}>

      {/* Header */}
      <div style={{ background: 'white', borderBottom: '1px solid #EDE5F8', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <svg width="28" height="35" viewBox="0 0 197 249" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M158.29,177.25c4.37,3.62,3.99,11.25,1.09,14.9-3.48,4.37-9.56,4.58-13.73,1.1l-48.6-40.52-.24,71.04c-.02,5.58-6.19,8.2-10.14,7.99-5.27-.27-9.86-3.75-9.89-9.84l-.29-69.51-47.82,41.21c-4.27,3.68-9.47,3.15-13.56-.41-2.97-2.58-4.95-10.22-.59-13.94l56.23-47.93L15.15,85.99c-4.5-3.67-3.42-10.67-.58-13.96,3.79-4.38,9.86-4.61,14.39-.94l47.62,38.59.09-91.63c0-4.41,1.79-8.05,5.23-9.8,2.94-1.5,7.95-1.51,10.98.9l29.47,23.46c5.92,4.72,10.1,11.62,4.75,18.78-3.06,4.09-9.99,3.9-14.06.58l-16.07-13.13v70.41s46.81-40.03,46.81-40.03l-12.93-12.02,31.27-6.11,22.14-4.2-17.67,53.75-8.72-17.32-55.58,47.57,56,46.38Z" fill="#3D1A6E"/>
          </svg>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: '0.1em', color: '#3D1A6E' }}>ODINFLOW</div>
            <div style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#7B4DBF', marginTop: -2 }}>Travel Distribution Software</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ fontSize: 13, color: '#6B6880' }}>{user?.email}</div>
          <button onClick={handleLogout} style={{ background: 'none', border: '1.5px solid #EDE5F8', borderRadius: 6, padding: '6px 14px', fontSize: 12, fontWeight: 700, color: '#6B6880', cursor: 'pointer', letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: 'inherit' }}>
            Sign out
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>

        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1C1C2E', margin: 0, marginBottom: 8 }}>Your Projects</h1>
          <p style={{ fontSize: 15, color: '#6B6880', margin: 0 }}>Start a new transport assessment or continue an existing one</p>
        </div>

        {/* New project */}
        {!showForm ? (
          <button
            onClick={() => setShowForm(true)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#3D1A6E', color: 'white', border: 'none', borderRadius: 8, padding: '14px 24px', fontSize: 13, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: 'inherit', marginBottom: 32 }}>
            + New Project
          </button>
        ) : (
          <div style={{ background: 'white', borderRadius: 10, padding: 24, marginBottom: 32, boxShadow: '0 2px 12px rgba(61,26,110,0.08)', border: '1.5px solid #EDE5F8' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#3D1A6E', marginBottom: 16, letterSpacing: '0.06em', textTransform: 'uppercase' }}>New Project</div>

            {field('Project Name', 'name', 'e.g. Bracknell Housing Development', true)}

            <div style={{ display: 'flex', gap: 12 }}>
              <div style={{ flex: 1 }}>{field('Project Number', 'projectNumber', 'e.g. 2024-001')}</div>
              <div style={{ flex: 1 }}>{field('Client', 'client', 'e.g. Acme Developments Ltd')}</div>
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <div style={{ flex: 1 }}>{field('Prepared By', 'preparedBy', 'e.g. R. Lewis')}</div>
              <div style={{ flex: 1 }}>{field('Checked By', 'checkedBy', 'e.g. J. Smith')}</div>
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
              <button onClick={handleCreate} disabled={!form.name.trim()}
                style={{ background: form.name.trim() ? '#3D1A6E' : '#EDE5F8', color: form.name.trim() ? 'white' : '#C4BDD4', border: 'none', borderRadius: 6, padding: '9px 20px', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: form.name.trim() ? 'pointer' : 'not-allowed', fontFamily: 'inherit' }}>
                Create Project
              </button>
              <button onClick={() => { setShowForm(false); setForm({ name: '', projectNumber: '', client: '', preparedBy: '', checkedBy: '' }); }}
                style={{ background: 'white', color: '#6B6880', border: '1.5px solid #EDE5F8', borderRadius: 6, padding: '9px 20px', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: 'inherit' }}>
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* Projects list */}
        {loading ? (
          <div style={{ fontSize: 14, color: '#7B4DBF' }}>Loading projects...</div>
        ) : projects.length === 0 ? (
          <div style={{ background: 'white', borderRadius: 10, padding: 40, textAlign: 'center', boxShadow: '0 2px 12px rgba(61,26,110,0.08)', border: '1.5px solid #EDE5F8' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📋</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1C1C2E', marginBottom: 8 }}>No projects yet</div>
            <div style={{ fontSize: 14, color: '#6B6880' }}>Create your first project to get started</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {projects.map(project => (
              <div key={project.id} style={{ background: 'white', borderRadius: 10, padding: '20px 24px', boxShadow: '0 2px 12px rgba(61,26,110,0.08)', border: '1.5px solid #EDE5F8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#1C1C2E', marginBottom: 4 }}>{project.name}</div>
                  <div style={{ fontSize: 12, color: '#6B6880', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    <span>Created {new Date(project.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                    {project.project_number && <span style={{ color: '#7B4DBF' }}>#{project.project_number}</span>}
                    {project.client && <span style={{ color: '#3D1A6E', fontWeight: 600 }}>{project.client}</span>}
                    {project.prepared_by && <span>Prepared by {project.prepared_by}</span>}
                    {project.selected_oas && project.selected_oas.length > 0 && (
                      <span style={{ color: '#0D9488' }}>{project.selected_oas.join(', ')}</span>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => onLoadProject(project)} style={{ background: '#3D1A6E', color: 'white', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: 'inherit' }}>
                    Open
                  </button>
                  <button onClick={() => deleteProject(project.id)} style={{ background: 'white', color: '#C4BDD4', border: '1.5px solid #E5E7EB', borderRadius: 6, padding: '8px 18px', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: 'inherit' }}>
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;